var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBook = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.55C0 0.246243 0.246243 0 0.55 0H1.03557C2.78491 0 4.49217 0.536596 5.92696 1.53738L6.55 1.97196L7.17304 1.53739C8.60783 0.536596 10.3151 0 12.0644 0H12.55C12.8538 0 13.1 0.246243 13.1 0.55V10.55C13.1 10.8189 12.9056 11.0483 12.6404 11.0925L10.827 11.3948C10.0944 11.5168 9.38427 11.7478 8.72002 12.0799L6.79597 13.0419C6.64113 13.1194 6.45887 13.1194 6.30403 13.0419L4.44438 12.1121C3.74085 11.7603 2.98606 11.5222 2.20804 11.4066L0.469132 11.1481C0.19957 11.108 0 10.8766 0 10.6041V0.55ZM6 2.92949L5.29766 2.43959C4.06508 1.57985 2.60174 1.11326 1.1 1.10028V10.1298L2.36977 10.3185C3.26267 10.4512 4.12891 10.7245 4.93632 11.1282L6 11.6601V2.92949ZM7.1 11.6601L8.22809 11.096C8.99041 10.7149 9.80545 10.4498 10.6462 10.3097L12 10.0841V1.10028C10.4983 1.11326 9.03492 1.57985 7.80234 2.43959L7.1 2.92949V11.6601Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBook);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Book.5f09eb28019fa96623ddd83e729d1f99.svg";